/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HistoryMemoRequest } from '../models/HistoryMemoRequest';
import type { PaginatedResponse_BusinessFullResponse_ } from '../models/PaginatedResponse_BusinessFullResponse_';
import type { PaginatedResponse_TaskFullResponse_ } from '../models/PaginatedResponse_TaskFullResponse_';
import type { TaskBulkDepartmentReplaceRequest } from '../models/TaskBulkDepartmentReplaceRequest';
import type { TaskBulkDepartmentReplaceResponse } from '../models/TaskBulkDepartmentReplaceResponse';
import type { TaskBulkStakeholderReplaceRequest } from '../models/TaskBulkStakeholderReplaceRequest';
import type { TaskBulkStakeholderReplaceResponse } from '../models/TaskBulkStakeholderReplaceResponse';
import type { TaskCreateRequest } from '../models/TaskCreateRequest';
import type { TaskFullCreateRequest } from '../models/TaskFullCreateRequest';
import type { TaskFullResponse } from '../models/TaskFullResponse';
import type { TaskJudgmentBasisBulkRequest } from '../models/TaskJudgmentBasisBulkRequest';
import type { TaskJudgmentBasisBulkResponse } from '../models/TaskJudgmentBasisBulkResponse';
import type { TaskUpdateRequest } from '../models/TaskUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskService {
    /**
     * Create Task
     * 세부실행과제 생성
     *
     * 새로운 세부실행과제를 생성합니다.
     * @returns TaskFullResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTask({
        requestBody,
    }: {
        requestBody: TaskCreateRequest,
    }): CancelablePromise<TaskFullResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Tasks
     * 세부실행과제 목록 조회 및 검색 (list_task.json 구조)
     *
     * 특정 워크스페이스의 세부실행과제를 예산, 성과 정보와 함께 조회합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * q: 검색 키워드 (선택사항)
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * start_date: 시작일 (YYYY-MM-DD 형식, end_date와 함께 사용)
     * end_date: 종료일 (YYYY-MM-DD 형식, start_date와 함께 사용)
     * department_id: 부서 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * assignee_id: 담당자 ID로 필터링 (선택사항)
     * sub_assignee_id: 부담당자 ID로 필터링 (선택사항)
     * manager_id: 관리자 ID로 필터링 (선택사항)
     * reviewer_id: 검토자 ID로 필터링 (선택사항)
     * stakeholder_id: 이해관계자 ID (OR 조건으로 모든 역할 검색, 선택사항)
     * status: 과제 상태 필터 ("incomplete" | "completed", 선택사항)
     * performance_status: 성과 상태 필터 ("incomplete" | "completed", 선택사항. 성과 미등록 과제는 incomplete)
     * @returns PaginatedResponse_TaskFullResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTasks({
        workspaceId,
        q,
        page = 1,
        perPage = 100,
        startDate,
        endDate,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        status,
        performanceStatus,
    }: {
        workspaceId: string,
        q?: string,
        page?: number,
        perPage?: number,
        startDate?: string,
        endDate?: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        status?: string,
        performanceStatus?: string,
    }): CancelablePromise<PaginatedResponse_TaskFullResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task',
            query: {
                'workspace_id': workspaceId,
                'q': q,
                'page': page,
                'per_page': perPage,
                'start_date': startDate,
                'end_date': endDate,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'status': status,
                'performance_status': performanceStatus,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk Replace Stakeholders
     * 세부실행과제 담당자/부담당자/관리자/검토자 일괄 교체
     *
     * 워크스페이스 내 모든 Task에서 기존 멤버를 새 멤버로 교체합니다.
     * - 역할별 선택적 교체 (미지정 역할은 변경 안 함)
     * - from_member_id: 교체 대상 기존 멤버 (null이면 비어있는 역할에 신규 지정)
     * - to_member_id: 새로 배정할 멤버
     * @returns TaskBulkStakeholderReplaceResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsBulkReplaceStakeholders({
        requestBody,
    }: {
        requestBody: TaskBulkStakeholderReplaceRequest,
    }): CancelablePromise<TaskBulkStakeholderReplaceResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/bulk-stakeholders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk Set Judgment Basis
     * 세부실행과제 판단 근거 일괄 저장
     *
     * AI 분석 시 프롬프트에 함께 실리는 과제별 판단 근거(`meta.judgment_basis`)를 일괄 저장합니다.
     * - `judgment_basis` 가 빈 문자열이면 해당 과제의 판단 근거를 삭제합니다.
     * - 존재하지 않는 과제 ID 는 건너뛰고 `not_found` 로 반환합니다(부분 실패로 전체를 되돌리지 않음).
     * - 개별 수정은 `PATCH /task/{task_id}` 의 `judgment_basis` 필드를 사용하세요.
     * @returns TaskJudgmentBasisBulkResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsBulkSetJudgmentBasis({
        requestBody,
    }: {
        requestBody: TaskJudgmentBasisBulkRequest,
    }): CancelablePromise<TaskJudgmentBasisBulkResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/bulk-judgment-basis',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Bulk Replace Department
     * 세부실행과제 부서 일괄 교체
     *
     * 워크스페이스 내 모든 Task에서 기존 부서를 새 부서로 교체합니다.
     * - from_department_id: 교체 대상 기존 부서 (null이면 부서 미지정 Task에 신규 지정)
     * - to_department_id: 새로 배정할 부서
     * @returns TaskBulkDepartmentReplaceResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsBulkReplaceDepartment({
        requestBody,
    }: {
        requestBody: TaskBulkDepartmentReplaceRequest,
    }): CancelablePromise<TaskBulkDepartmentReplaceResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/task/bulk-department',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List All Task In Workspace
     * 워크스페이스 내 모든 작업의 전체 계층구조 조회
     *
     * 특정 워크스페이스의 모든 business → task_group → task_subgroup → task → task_item
     * 계층구조를 완전한 세부정보와 함께 조회합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * q: 검색 키워드 (선택사항) - 과제명으로 검색
     * start_date: 시작일 (YYYY-MM-DD 형식, end_date와 함께 사용)
     * end_date: 종료일 (YYYY-MM-DD 형식, start_date와 함께 사용)
     *
     * Returns:
     * PaginatedResponse: 사업별 작업 계층구조 목록
     * @returns PaginatedResponse_BusinessFullResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListAllTaskInWorkspace({
        workspaceId,
        page = 1,
        perPage = 100,
        q,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        page?: number,
        perPage?: number,
        q?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<PaginatedResponse_BusinessFullResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/workspace-all',
            query: {
                'workspace_id': workspaceId,
                'page': page,
                'per_page': perPage,
                'q': q,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create Task Full
     * 세부실행과제 전체 생성
     *
     * Task, TaskMap을 한번에 생성하고 전체 정보를 반환합니다.
     *
     * Args:
     * data: Task Full 생성 요청 데이터 (workspace_id 포함)
     *
     * Returns:
     * TaskFullResponse: 생성된 Task의 전체 정보 (workspace-all 형식)
     * @returns TaskFullResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskFull({
        requestBody,
    }: {
        requestBody: TaskFullCreateRequest,
    }): CancelablePromise<TaskFullResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/full',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task
     * 세부실행과제 상세 조회
     *
     * ID로 특정 세부실행과제의 전체 정보를 조회합니다.
     * 워크스페이스, 부서, 담당자, 예산, 성과 정보를 포함합니다.
     * @returns TaskFullResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTask({
        taskId,
    }: {
        taskId: string,
    }): CancelablePromise<TaskFullResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task
     * 세부실행과제 정보 수정
     *
     * 특정 세부실행과제의 정보를 수정합니다.
     * @returns TaskFullResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTask({
        taskId,
        requestBody,
    }: {
        taskId: string,
        requestBody: TaskUpdateRequest,
    }): CancelablePromise<TaskFullResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/{task_id}',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task
     * 세부실행과제 삭제
     *
     * 특정 세부실행과제를 삭제합니다. (소프트 삭제)
     * 선택적으로 body 에 memo 를 담으면 history 에 기록됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTask({
        taskId,
        requestBody,
    }: {
        taskId: string,
        requestBody?: HistoryMemoRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/{task_id}',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
